// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "bvoy-82a9a.firebaseapp.com",
  "projectId": "bvoy-82a9a",
  "storageBucket": "bvoy-82a9a.appspot.com",
  "messagingSenderId": "833053264845",
  "appId": "1:833053264845:web:ab1d41ea0f71fe144b5284",
  "measurementId": "G-TZ5D2P28M0",
  "apiKey": "AIzaSyCy79REAqr6eIRfQ811QVbDHzf9YPjBkzI"
};
